import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { UserPlus, SignOut, PresentationChart } from "@phosphor-icons/react";
import { OnboardingWorkflows } from "./OnboardingWorkflows";
import { OffboardingTasks } from "./OffboardingTasks";

export function LifecycleDashboard() {
  const [activeTab, setActiveTab] = useState("onboarding");

  return (
    <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
      <div className="flex flex-col gap-2">
        <h2 className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-slate-900 to-slate-700 dark:from-white dark:to-slate-300">
          Employee Lifecycle
        </h2>
        <p className="text-slate-500 dark:text-slate-400">
          Manage onboarding journeys and exit processes.
        </p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-2 lg:w-auto">
          <TabsTrigger value="onboarding" className="gap-2">
            <UserPlus className="w-4 h-4" />
            <span className="hidden md:inline">Onboarding</span>
          </TabsTrigger>
          <TabsTrigger value="offboarding" className="gap-2">
            <SignOut className="w-4 h-4" />
            <span className="hidden md:inline">Offboarding</span>
          </TabsTrigger>
        </TabsList>

        <div className="mt-6">
          <TabsContent value="onboarding" className="space-y-4">
            <OnboardingWorkflows />
          </TabsContent>

          <TabsContent value="offboarding" className="space-y-4">
            <OffboardingTasks />
          </TabsContent>
        </div>
      </Tabs>
    </div>
  );
}
